import { useEffect, useState } from "react";
import SyIcon from "../../../../shared/components/sy-icon";
import styleSheet from "./style.module.scss";
import { useMutation } from "@tanstack/react-query";
import citizenService from "../../services/citizen-service";
import { useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../feature/orbit-slice";
import { DETAILCONFIG } from "./config";
import dayjs from "dayjs";
import { getImageDetails } from "../../../../feature/image-slice";

const DetailPopup = (props: any) => {
  const { onClose, listMode } = props;
  const imageDetails = useSelector(getImageDetails);
  const [listData, setListData] = useState<any>([]);
  const ORBIT_SLICE_DATA = useSelector(getOrbitDetails);

  useEffect(() => {
    getListData();
  }, []);

  const { mutate: likeCount } = useMutation({
    mutationFn: citizenService.likeCount,
    onSuccess(data, variables, context) {
      setListData(data.data);
    },
  });

  const { mutate: engageCount } = useMutation({
    mutationFn: citizenService.engageCount,
    onSuccess(data, variables, context) {
      setListData(data.data);
    },
  });
  const getListData = () => {
    if (listMode === "like") {
      likeCount(ORBIT_SLICE_DATA.volunteersDetails);
    } else if (listMode === "engage") {
      engageCount(ORBIT_SLICE_DATA.volunteersDetails)
    }
  };
  const getTableHeaders = ({ th_classname, th_name, index }: any) => {
    return (
      <th key={index} className={`${th_classname} text-truncate`} scope="col">
        {th_name}
      </th>
    );
  };

  const getTableContent = ({ data, index }: any) => {
    return (
      <tr key={index} className="lh-lg">
        {DETAILCONFIG[listMode].table_content.map((content: any, i: number) => (
          content.td_name === "created" ? (
            <>
              <td key={`${i}-date`} className="text-truncate">
                {dayjs(data[content.td_name]).format("DD-MM-YYYY")}
              </td>
              <td key={`${i}-time`} className="text-truncate">
                {dayjs(data[content.td_name]).format("HH:mm")} Uhr
              </td>
            </>
          ) : content.td_name === "category_image_url" ? (
            <td key={i} className="px-3 py-2">
              <img
                className={`${styleSheet.image} rounded-circle`}
                src={data?.[content.td_name] || imageDetails.default[0].img}
                alt="category"
              />
            </td>
          ) : (
            <td key={i} className="px-3 py-2 text-truncate">
              {data[content.td_name]}
            </td>
          )
        ))}
      </tr>
    );
  };

  return (
    <>
      <div className={`rounded-4  p-3 pop-bg ${styleSheet.list}`}>
        <div className="d-flex align-items-center justify-content-between pb-3">
          <h2 className="mohave m-0 title-font">
            {DETAILCONFIG[listMode].header}
          </h2>
          <SyIcon
            name="close"
            iconType="symbols"
            iconStyle="outlined"
            iconColor="white"
            className={` pointer`}
            onClick={onClose}
          />
        </div>
        <div className="mt-3">
          <table className={`table_style w-100`}>
            <thead className="lh-lg mohave-bold ">
              <tr>
                {DETAILCONFIG[listMode].table_header.map(
                  (data: any, index: number) =>
                    getTableHeaders({ ...data, index: index })
                )}
              </tr>
            </thead>
            <tbody className="position-relative mohave">
              {listData.length ? (
                listData.map((data: any, index: number) =>
                  getTableContent({ data, index: index })
                )
              ) : (
                <div className=" position-absolute position-absolute mt-5 end-50">
                  <p>no data found</p>
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default DetailPopup;
